import classNames from 'classnames';
import { VFC } from 'react';

import styles from './ProcessResultAlert.module.scss';

type Status = 'wait' | 'success' | 'fail';

type Props = {
  status: Status;
  message?: string | null;
  successMessage?: string;
  failMessage?: string;
};

const ProcessResultAlert: VFC<Props> = ({
  status,
  message: _message,
  successMessage,
  failMessage,
}: Props) => {
  const className = classNames(styles.processResultAlert, {
    [styles.success]: status === 'success',
    [styles.fail]: status === 'fail',
  });

  if (status !== 'wait') {
    let message = status === 'fail' ? 'Failed!' : 'Completed!';

    if (_message) {
      message = _message;
    } else if (status === 'success' && successMessage) {
      message = successMessage;
    } else if (status === 'fail' && failMessage) {
      message = failMessage;
    }

    return <div className={className}>{message}</div>;
  }

  // No alert is shown if status is `wait`
  return null;
};

export default ProcessResultAlert;
